module.exports = __webpack_public_path__ + "60950dd57978dc8a8512e3c97e6b824a.pdf";